import React from 'react';
import { toast } from 'react-toastify';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as CloseBtn } from '../../../../assets/icons/close.svg';
import BlackButton from '../../../../components/BlackButton';
import { useEffect } from 'react';
import { MAX_UPLOAD_FILE_SIZE } from '../../../../components/Constants/FileUpload';
import { useRef } from 'react';
import $ from 'jquery';
import ExampleCustomCodeTemplate from './../../../../sample-csv/custom-code-template.xlsx';


const UpdateQuantity = () => {


    const state = useLocation();
    const navigate = useNavigate();
    const [id, setId] = useState("");
    const [quantity, setQuantity] = useState("");
    const [previousData, setPreviousData] = useState({});

    const fileInput2 = useRef();
    const [file2, setFile2] = useState();

    const selectFile2 = () => {
        fileInput2.current.click();
    }

    
    const handleChange2 = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }
        
        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        if (!e.target.files[0]["type"].includes("application/vnd.")) {
            toast.error("Please upload valid excel");
            return;
        }

        setFile2(e.target.files[0]);
    }
    
    const [isCode, setIsCode] = useState(previousData.is_code ? 1 : 0);
    // const switchQuantity = (event) => {
    //     setIsCode(0);
    //     setFile2();
    //     $("#quantity").attr("required", false);
    //     $("#code_csv").attr("required", false);

    //     $("#quantity_div").hide();
    //     $("#voucher_div").hide();
        
    //     if( event.target.checked === true) {
    //         $("#code_csv").attr("required", true);
    //         $("#voucher_div").show();
    //         setIsCode(1);
    //         return;
    //     }

    //     $("#quantity").attr("required", true);
    //     $("#quantity_div").show();
    // }


    const onSubmit = (e) => {
        e.preventDefault();

        if (id === "") {
            toast.error("No item id found.");
            return;
        }


        if (quantity === "") {
            toast.error("Please enter quantity.");
            return;
        }




        let qty = 1;
        if(isCode === 1) {
            if(file2 === undefined) {
                toast.error("Please upload a valid code csv file");
                return;
            }
        }
        else {
            qty = $("#quantity").val();
        }

        
        let reqBody = new FormData();
        reqBody.append("is_code", isCode);
        reqBody.append("stock_quantity", qty);
        reqBody.append("custom_code_csv", file2);

        
        $("#update_btn").attr("disabled",true);
        $("#update_btn").html("Loading");

        PostLoginPostApi("item/quantity/" + id, reqBody, 1, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success("Quantity update successfully.");
                    navigate("/dashboard/store");
                    return;
                }

                let message = ( responseData["messages"] ?? responseData["message"] ) ?? "A problem occur. Please try again.";
                toast.error(message + " ");
            }
        }).catch((error) => {
            console.log(error);
            toast.error("A problem occur. Please try again.");

        }).finally(()=>{
            $("#update_btn").attr("disabled",false);
            $("#update_btn").html("Update");
        });
    }


    useEffect(() => {
        if (state?.state?.data?.id === undefined) {
            return navigate("/dashboard/store");
        }

        if (state?.state?.data?.stock_quantity === undefined) {
            return navigate("/dashboard/store");
        }


        setId(state.state.data.id);
        setQuantity(state.state.data.stock_quantity);
        setPreviousData(state.state.data);


        setIsCode(state.state.data?.is_code ? 1 : 0);

    }, [state]);



    return (
        <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
            <header className="p-4 border-b-2 border-dark-white mb-[60px]">
                <Link to="/dashboard/store"><CloseBtn className="float-left" /></Link>
                <p className="text-center">Update Quantity</p>
            </header>
            <main className="max-w-2xl m-auto">

                <form onSubmit={onSubmit}>


                    <div className="flex items-center relative pb-4 pt-2">
                        <h1 className="text-base font-semibold pl-1 pr-4 w-[200px]">Is Custom Code ?</h1>
                        <label className='font-semibold'>
                            
                            {/* <input id="is_code" name="is_code" className="toggle-checkbox" type="checkbox" placeholder="is_code" onClick={(event) => switchQuantity(event)} defaultChecked={previousData.is_code} />

                            <div className="toggle-switch"></div>
                            <span className="toggle-label"></span> */}

                            {(previousData.is_code === 1) ? <>Yes</> : <>No</> }
                        </label>
                    </div>


                    {(previousData.is_code) ? 
                    <>
                        <div className='flex items-center align-middle mt-2' id="quantity_div" style={{display: "none"}}>
                            <h1 className="text-base font-semibold pl-1 pr-4 w-[200px]">Stock Quantity *</h1>
                            <div className="relative">
                                <input type="text" id="quantity" name="quantity" value={quantity} onChange={(event) => setQuantity(event.currentTarget.value)} placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" maxLength={5} />

                                <label htmlFor="quantity" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1.5">Enter Quantity</label>
                            </div>
                        </div>


                        <div className='flex items-center align-middle mt-2' id="voucher_div" >
                            <h1 className="text-base font-semibold pl-1 pr-4 w-[200px]">
                                Code CSV *
                                <Link to={ExampleCustomCodeTemplate} download="Example-custom-code-template" target="_blank" rel="noreferrer" className='text-xs font-normal block -mt-1'>Download Sample</Link>
                            </h1>
                            <div className="flex relative w-full bg-[#f5f5f5] p-2 rounded-md" style={{ border: "1px solid #e0e0e0", marginLeft: "55px" }}>
                                <input type="file" name="code_csv" id="code_csv" className="hidden" ref={fileInput2} onChange={handleChange2} />

                                {file2 ?
                                    <>
                                        <span className='text-sm pt-[6px]' title={file2.name}>
                                            {file2.name.toString().substring(0, 28)}
                                            {(file2.name.length > 28) && <>...</>}
                                        </span>
                                        <button type="button" className="text-white ml-auto float-right order-3 bg-[#444] py-[8px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs" onClick={selectFile2}>Change</button>
                                    </> :
                                    <>
                                        <label htmlFor="logo" className="p-1 pt-[5px] text-base font-medium">Upload Code CSV</label>
                                        <button type="button" className="text-white ml-auto order-2 bg-[#1A202C] py-[8px] px-[10px] rounded-[3px] cursor-pointer block justify- text-sm" onClick={selectFile2}>Upload</button>
                                    </>
                                }
                            </div>
                        </div>
                    </> : 
                    <>
                        <div className='flex items-center align-middle mt-2' id="quantity_div">
                            <h1 className="text-base font-semibold pl-1 pr-4 w-[200px]">Stock Quantity *</h1>
                            <div className="relative">
                                <input type="text" id="quantity" name="quantity" value={quantity} onChange={(event) => setQuantity(event.currentTarget.value)} placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" maxLength={5} />

                                <label htmlFor="quantity" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1.5">Enter Quantity</label>
                            </div>
                        </div>


                        <div className='flex items-center align-middle mt-2' id="voucher_div" style={{display: "none"}}>
                            <h1 className="text-base font-semibold pl-1 pr-4 w-[200px]">
                                Code CSV *
                                <Link to={ExampleCustomCodeTemplate} download="Example-custom-code-template" target="_blank" rel="noreferrer" className='text-xs font-normal block -mt-1'>Download Sample</Link>
                            </h1>
                            <div className="flex relative w-full bg-[#f5f5f5] p-2 rounded-md" style={{ border: "1px solid #e0e0e0", marginLeft: "55px" }}>
                                <input type="file" name="code_csv" id="code_csv" className="hidden" ref={fileInput2} onChange={handleChange2} />

                                {file2 ?
                                    <>
                                        <span className='text-sm pt-[6px]' title={file2.name}>
                                            {file2.name.toString().substring(0, 28)}
                                            {(file2.name.length > 28) && <>...</>}
                                        </span>
                                        <button type="button" className="text-white ml-auto float-right order-3 bg-[#444] py-[8px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs" onClick={selectFile2}>Change</button>
                                    </> :
                                    <>
                                        <label htmlFor="logo" className="p-1 pt-[5px] text-base font-medium">Upload Code CSV</label>
                                        <button type="button" className="text-white ml-auto order-2 bg-[#1A202C] py-[8px] px-[10px] rounded-[3px] cursor-pointer block justify- text-sm" onClick={selectFile2}>Upload</button>
                                    </>
                                }
                            </div>
                        </div>
                    </>
                    }

                    <br></br>
                    <BlackButton id="update_btn" name="Update" />
                </form>

            </main>
        </div>
    );
};

export default UpdateQuantity;